export default "__VITE_ASSET__CO91OIfc__"